export default {
    contained: {
        boxShadow:
            '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
        backgroundColor: '#FFFFFF'
    },
    outlined: {
        borderRadius: 11,
        color: 'black'
    },
    outlinedPrimary: {
        border: '1px solid #f39c12',
        color: '#f39c12',
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': {
            border: '1px solid #f39c12',
            backgroundColor: 'rgba(243, 156, 18, 0.08)',
        },
    },
    outlinedSecondary: {
        border: '1px solid #2c3e50',
        color: '#2c3e50',
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': {
            border: '1px solid #2c3e50',
            backgroundColor: 'rgba(44, 62, 80, 0.08)',
        },
    },
    containedPrimary: {
        boxShadow: 'none',
        backgroundColor: '#f39c12',
        color: '#222',
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#fca61c',
            boxShadow: 'none',
            '@media (hover: none)': {
                backgroundColor: '#f39c12',
            },
        },
    },
    containedSecondary: {
        boxShadow: 'none',
        backgroundColor: '#2c3e50',
        color: 'white',
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#39526b',
            boxShadow: 'none',
            '@media (hover: none)': {
                backgroundColor: '#2c3e50',
            },
        },
    },
    
};
